import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/loader/loader.service';

@Injectable()
export class LoaderInterceptorInterceptor implements HttpInterceptor {

  constructor(private _loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    
    this._loaderService.loaderStatus.next(true);

    return next.handle(request).pipe(
      finalize(() => {
        this._loaderService.loaderStatus.next(false);
      })
    );
  }
}
